<template>
  <div>
    <div class="tags-container">
      <div
        v-if="permissions.create"
        @click="showModal.create = true"
        class="add-icon icon">
      </div>
      <div v-for="(tag, key) in tags" :key="key">
        <div class="tag-container">
          <div
            class="tag-inner-container"
            :class="{
              active: selectedTags.includes(tag.id),
              editmode: permissions.edit && tag.id != 'ALL'
            }"
            :tag-id="tag.id"
            @click="handleTagClick(tag.id)"
          >
            <span class="tag">{{ tag.name }}</span>
          </div>

          <div v-if="tag.id !== 'ALL'" class="action-bar">
            <Modal
              title="Edit Tag"
              :show="showModal.edit[tag.id]"
              @close="showModal.edit[tag.id] = false">
              <UpdateTag
                :tagId="tag.id"
                :tagName="tag.name"
                :deletePermission="permissions.delete"
                :successCallback="onUpdateTag"
                :deleteCallback="onDeleteTag"
              ></UpdateTag>
            </Modal>
          </div>
        </div>
      </div>
    </div>
    <Modal
      title="Create Tag"
      :show="showModal.create"
      @close="showModal.create = false"
    >
      <CreateTag
        :topic="topic"
        :successCallback="onCreateTag"
      ></CreateTag>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/components/modal.vue';
import CreateTag from '@/components/tag-create.vue';
import UpdateTag from '@/components/tag-update.vue';

import dynamoDB from '@/aws/aws-dynamoDB';

export default {
  components: {
    Modal,
    CreateTag,
    UpdateTag,
  },
  props: {
    topic: {
      type: String,
      required: true,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    enableAllTag: {
      type: Boolean,
      default: false,
    },
    initialTags: {
      type: Array,
      default: () => [],
    },
    permissions: {
      type: Object,
      default: () => ({
        create: false,
        delete: false,
        edit: false,
      }),
    },
    selectCallback: {
      type: Function,
      default: activeTags => activeTags,
    },
    updateCallback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      tags: [],
      selectedTags: this.enableAllTag && this.initialTags.length === 0 ? ['ALL'] : this.initialTags,
      showModal: {
        create: false,
        remove: {},
        edit: {},
      },
    };
  },
  async created() {
    await this.generateTags();
  },
  methods: {
    async generateTags() {
      const tags = await this.getTags();
      const sortedTags = tags.sort((a, b) => a.name.localeCompare(b.name));
      this.tags = this.enableAllTag ? [{ id: 'ALL', name: 'All' }, ...sortedTags] : sortedTags;

      const edit = {};
      const remove = {};
      this.tags.forEach((tag) => {
        if (tag.id === 'ALL') {
          return;
        }
        edit[tag.id] = false;
        remove[tag.id] = false;
      });
      this.showModal = {
        create: false,
        edit,
        remove,
      };
    },
    async getTags() {
      return dynamoDB.getDBTagsByTopic(this.topic);
    },
    async updateTag(id, name) {
      return dynamoDB.updateDBTag(id, name);
    },
    toggleTag(tagId) {
      if (tagId === 'ALL') {
        this.selectedTags = ['ALL'];
        // signal to parent component that ALL tags are selected
        this.selectCallback(this.tags.map(tag => tag.id));
        return;
      }

      if (this.selectedTags.includes(tagId)) {
        this.selectedTags = this.selectedTags.filter(id => id !== tagId);
        if (this.selectedTags.length === 0 && this.enableAllTag) {
          this.selectedTags = ['ALL'];
        }
      } else {
        this.selectedTags.push(tagId);
        if (this.selectedTags.includes('ALL')) {
          this.selectedTags = this.selectedTags.filter(id => id !== 'ALL');
        }
      }
      // signal to parent component which tags are selected
      this.selectCallback(this.selectedTags);
    },
    handleTagClick(tagId) {
      if (this.editMode) {
        this.showModal.edit[tagId] = true;
      } else {
        this.toggleTag(tagId);
      }
    },
    onCreateTag() {
      this.generateTags();
      this.updateCallback();
    },
    onDeleteTag() {
      this.generateTags();
      this.updateCallback();
    },
    onUpdateTag() {
      this.generateTags();
      this.updateCallback();
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .tags-container
    display: flex
    flex-flow: row wrap
    justify-content: center
    align-items: center
    gap: 1.5rem

    .tag-container
    .tag-inner-container
      display: flex
      flex-flow: row nowrap
      justify-content: center
      align-items: center
      gap: .5rem

    .tag-inner-container
      gap: 2.5rem
      padding: 1rem 2.5rem
      border-radius: 2rem
      border: 3px solid $primary-color
      color: $primary-color
      cursor: pointer
      transition: all 0.3s ease-in-out

      &.editmode
        border-style: dashed

      &:hover
        background-color: $primary-color
        color: $white
        transform: scale(1.1)

      &.active
        background-color: $primary-color
        color: $white

    .action-bar
      display: flex
      flex-flow: row nowrap
      justify-content: center
      align-items: center
      gap: .5rem

    .tag
      font-size: 1.5rem
      font-family: space-grotesk
      font-size: 1.5rem
      font-weight: 900


  .icon
    width: 30px
    height: 30px
    background-size: contain
    cursor: pointer
  .edit-icon
    background: url('../assets/edit_name_document.svg') no-repeat
    width: 10px
    height: 10px
    transform: scale(2.3);

  .delete-icon
    background: url('../assets/delete_document.svg') no-repeat
  .add-icon
    background: url('../assets/addButton.svg') no-repeat
    background-size: contain

</style>
